import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleRipple } from '../../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  ImageSection,
  Image,
  ContentSection,
  Title,
  Text,
  Button,
  Orangecircle,
} from './styled';

const Learn = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageSection>
          <Image
            src={formatMessage({ id: 'home.spendrewards.learn.image.src' })}
            alt={formatMessage({ id: 'home.spendrewards.learn.image.alt' })}
            loading="lazy"
          />
        </ImageSection>
        <ContentSection>
          <Title>
            <FormattedMessage id="home.spendrewards.learn.title" />
          </Title>
          <Text>
            <FormattedMessage id="home.spendrewards.learn.text" />
          </Text>
          <Button
            href={formatMessage({
              id: 'home.spendrewards.learn.buttonLink',
            })}
            target="_blank"
            onMouseEnter={handleRipple}
          >
            <FormattedMessage id="home.spendrewards.learn.buttonText" />
            <Orangecircle src="/images/uploads/Icon.svg" alt="Black Icon" />
          </Button>
        </ContentSection>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const LearnFragment = graphql`
  fragment Learn on Json {
    spendrewards {
      learn {
        image {
          src
          alt
        }
        title
        text
        buttonText
        buttonLink
      }
    }
  }
`;

export default Learn;
